export const rootUrl = {
  path: '/:tenant' as const,
  navigate: () => window.location.pathname.split('/')[1] || '',
}

export const routes = {
  // TODO HIDE - don't delete
  // dashboard: {
  //   path: `${rootUrl.path}/` as const,
  //   navigate: () => `../${rootUrl.navigate()}/`,
  // },

  projects: {
    path: `${rootUrl.path}/projects` as const,
    navigate: () => `../${rootUrl.navigate()}/projects`,
  },

  certifications: {
    path: `${rootUrl.path}/certifications` as const,
    navigate: () => `../${rootUrl.navigate()}/certifications`,
  },

  certification: {
    path: `${rootUrl.path}/certifications/:id` as const,
    navigate: (id: string) => `../${rootUrl.navigate()}/certifications/${id}`,
  },

  contributors: {
    path: `${rootUrl.path}/contributors` as const,
    navigate: () => `../${rootUrl.navigate()}/contributors`,
  },

  contributor: {
    path: `${rootUrl.path}/contributors/:id` as const,
    navigate: (idProject: string) => `../../${rootUrl.navigate()}/contributors/${idProject}`,
  },

  informations: {
    path: `${rootUrl.path}/informations` as const,
    navigate: () => `../${rootUrl.navigate()}/informations`,
  },

  // TODO HIDE - don't delete
  // activity: {
  //   path: `${rootUrl.path}/activity` as const,
  //   navigate: () => `../${rootUrl.navigate()}/activity`,
  // },
}

// export type TAvailableRoutes = keyof typeof routes
